module.exports = __webpack_public_path__ + "img/FED_Logo03.1f677f86.svg";